import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import AppActions from '../App/actions';
import {deleto, get, post, puto} from 'bukku/shared/ApiService';
import {t} from "@lingui/macro";

// Create field
export function* createFieldRequest() {
    yield takeEvery(actions.FIELD_CREATE_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(post, '/fields', request, context);

            // OK
            yield put({
                type: actions.FIELD_CREATE_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.FIELD_CREATE_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* createFieldSuccess() {
    yield takeEvery(actions.FIELD_CREATE_SUCCESS, function* () {
        yield message.success(t`The field is created.`);
    });
}
export function* createFieldFail() {
    yield takeEvery(actions.FIELD_CREATE_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read fields
export function* readFieldListRequest() {
    yield takeEvery(actions.FIELD_READ_LIST_REQUEST, function* ({ request}, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/fields', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.FIELD_READ_LIST_SUCCESS,
                fields: data.fields,
                pagination: data.paging,
            });
        }
        catch (error) {
            yield put({
                type: actions.FIELD_READ_LIST_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readFieldListSuccess() {
    yield takeEvery(actions.FIELD_READ_LIST_SUCCESS, () => {});
}
export function* readFieldListFail() {
    yield takeEvery(actions.FIELD_READ_LIST_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read field
export function* readFieldRequest() {
    yield takeEvery(actions.FIELD_READ_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, `/fields/${id}`, null, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.FIELD_READ_SUCCESS,
                field: data.field,
            });
        }
        catch (error) {
            yield put({
                type: actions.FIELD_READ_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readFieldSuccess() {
    yield takeEvery(actions.FIELD_READ_SUCCESS, () => {});
}
export function* readFieldFail() {
    yield takeEvery(actions.FIELD_READ_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Update field
export function* updateFieldRequest() {
    yield takeEvery(actions.FIELD_UPDATE_REQUEST, function* ({ id, request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(puto, `/fields/${id}`, request, context);

            // OK
            yield put({
                type: actions.FIELD_UPDATE_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.FIELD_UPDATE_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateFieldSuccess() {
    yield takeEvery(actions.FIELD_UPDATE_SUCCESS, function* () {
        yield message.success(t`The field is updated.`);
    });
}
export function* updateFieldFail() {
    yield takeEvery(actions.FIELD_UPDATE_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Delete field
export function* deleteFieldRequest() {
    yield takeEvery(actions.FIELD_DELETE_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(deleto, `/fields/${id}`, null, context);

            // OK
            yield put({
                type: actions.FIELD_DELETE_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.FIELD_DELETE_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* deleteFieldSuccess() {
    yield takeEvery(actions.FIELD_DELETE_SUCCESS, function* () {
        yield message.success(t`The field is deleted.`);
    });
}
export function* deleteFieldFail() {
    yield takeEvery(actions.FIELD_DELETE_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(createFieldRequest),
        fork(createFieldSuccess),
        fork(createFieldFail),
        fork(readFieldListRequest),
        fork(readFieldListSuccess),
        fork(readFieldListFail),
        fork(readFieldRequest),
        fork(readFieldSuccess),
        fork(readFieldFail),
        fork(updateFieldRequest),
        fork(updateFieldSuccess),
        fork(updateFieldFail),
        fork(deleteFieldRequest),
        fork(deleteFieldSuccess),
        fork(deleteFieldFail),
    ]);
}
